import React from 'react';
import { bonuses } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Bonuses() {
  return <section className="w-full bg-bone px-5 py-20 sm:py-28" data-id="element-16" data-mp="plslc7o6v6at">
      <div className="mx-auto max-w-6xl" data-id="element-17" data-mp="aua8ujujftw7">
        <SectionHeading eyebrow="Incluidos hoy gratis" title={<>
              5 Bonos de <span className="text-brand" data-id="element-19" data-mp="fs3dh8g70fud">Ejecución Inmediata</span>
            </>} subtitle="Estos recursos se añaden a tu kit sin costo adicional, diseñados para una inmersión total y un ahorro real de tiempo." data-id="element-18" data-mp="fu6cuj38jlbr" />

        <ol className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="5tnmr6l2v8le">
          {bonuses.map((bonus, index) => <Reveal key={bonus.title} delay={index * 0.04} className="h-full" data-id="element-21" data-mp="3t0ok2b1f9pqw" data-mpi={index}>
              <li className="flex h-full flex-col overflow-hidden rounded-2xl border-2 border-ink bg-white transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-22" data-mp="3t2smspnl4ipl">
                <div className="relative border-b-2 border-ink bg-white" data-id="element-23" data-mp="1r80gg0kv90al">
                  <img src={bonus.cover} alt={`Cuadernillo del bono ${index + 1}: ${bonus.title}`} loading="lazy" className="mx-auto block h-60 w-full object-contain p-4" data-id="element-24" data-mp="3idmz7yg0j9gl" />
                  <span className="absolute left-4 top-4 rounded-full bg-ink px-3 py-1 font-display text-xs tracking-[0.1em] text-volt" data-id="element-25" data-mp="3r6qhck1lsahk">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="absolute right-4 top-4 rounded-full bg-volt px-3 py-1 font-display text-xs tracking-[0.1em] text-ink" data-id="element-26" data-mp="2zesjon8q64zd">
                    Gratis
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6" data-id="element-27" data-mp="38hbhuu1kftfa">
                  <h3 className="font-display text-xl leading-tight text-ink" data-id="element-28" data-mp="33h5o98bqjwuk">
                    {bonus.title}
                  </h3>
                  <p className="mt-3 flex-1 text-base leading-relaxed text-ink/70" data-id="element-29" data-mp="nozzqtl08ea6">
                    {bonus.text}
                  </p>
                </div>
              </li>
            </Reveal>)}

          <Reveal delay={0.24} className="h-full" data-id="element-30" data-mp="3chv4fnymz8ll">
            <li className="flex h-full flex-col items-start justify-center rounded-2xl border-2 border-ink bg-brand p-8 text-white" data-id="element-31" data-mp="3cl94gpjtv5pv">
              <p className="font-display text-sm tracking-[0.14em] text-white/80" data-id="element-32" data-mp="3ljcsbsiaceku">
                Los 5 bonos
              </p>
              <p className="mt-3 font-display text-5xl leading-none" data-id="element-33" data-mp="3qi5uwpw1al68">
                Incluidos gratis
              </p>
              <p className="mt-4 text-base leading-relaxed text-white/85" data-id="element-34" data-mp="2tqc2lkgcm0l5">
                Se suman hoy al kit completo, sin cargo adicional.
              </p>
            </li>
          </Reveal>
        </ol>
      </div>
    </section>;
}